import React from "react";
import { GridGenerator } from "@actinc/dls/components";
import { Box } from "@mui/material";
import { useFormContext } from "react-hook-form";

import {
  ControlledFormInput,
  ControlledFormSwitch,
} from "../../../../components";

const TextEntryInteractionForm = ({ index, interaction, readonly }) => {
  const namePrefix = `item.interactions[${index}]`;
  console.debug(
    "ExtendedTextInteractionForm - index %s, interaction %o",
    index,
    interaction
  );

  const { control, getValues } = useFormContext();

  if (!getValues(`${namePrefix}.identifier`)) return null;

  return (
    <Box
      sx={{
        alignItems: "self-start",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
      }}
    >
      <GridGenerator
        groups={[
          [
            {
              children: (
                <ControlledFormInput
                  control={control}
                  defaultValue={interaction.placeholderText}
                  fullWidth={true}
                  id={`${namePrefix}.placeholderText`}
                  label="Placeholder Text"
                  multiline={false}
                  name={`${namePrefix}.placeholderText`}
                  readonly={readonly}
                />
              ),
              key: `${namePrefix}.placeholderText`,
            },
            {
              children: (
                <ControlledFormInput
                  control={control}
                  defaultValue={interaction.correctResponse}
                  fullWidth={true}
                  id={`${namePrefix}.correctResponse`}
                  label="Correct Response"
                  multiline={false}
                  name={`${namePrefix}.correctResponse`}
                  readonly={readonly}
                />
              ),
              key: `${namePrefix}.correctResponse`,
            },
          ],
          [
            {
              children: (
                <ControlledFormInput
                  control={control}
                  defaultValue={interaction.patternMask}
                  id={`${namePrefix}.patternMask`}
                  label="Pattern Mask"
                  multiline={false}
                  name={`${namePrefix}.patternMask`}
                  readonly={readonly}
                />
              ),
              key: `${namePrefix}.patternMask`,
            },
            {
              children: (
                <ControlledFormInput
                  control={control}
                  defaultValue={interaction.expectedLength}
                  fullWidth={true}
                  id={`${namePrefix}.expectedLength`}
                  label="Maximum Characters"
                  multiline={false}
                  name={`${namePrefix}.expectedLength`}
                  readonly={readonly}
                  rules={{
                    maxLength: 3,
                    pattern: {
                      message: "This field must contain a valid number",
                      value: /^\d+$/,
                    },
                    required: true,
                  }}
                />
              ),
              key: `${namePrefix}.expectedLength`,
            },
            {
              children: (
                <ControlledFormSwitch
                  control={control}
                  defaultValue={interaction.ignoreCase}
                  fullWidth={true}
                  id={`${namePrefix}.ignoreCase`}
                  label="Ignore Case"
                  name={`${namePrefix}.ignoreCase`}
                  readonly={readonly}
                />
              ),
              key: `${namePrefix}.ignoreCase`,
            },
          ],
        ]}
      />
    </Box>
  );
};

export { TextEntryInteractionForm };
